import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../../../api/quarkusApi';

export function useNpsList() {
  const navigate = useNavigate();

  const [npsList, setNpsList] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchNpsList = useCallback(() => {
    setLoading(true);
    quarkusApi
      .get('/nps', { headers: { Authorization: sessionStorage.getItem('token') } })
      .then((returnFromApi) => setNpsList(returnFromApi.data))
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.response?.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [navigate]);

  useEffect(() => {
    fetchNpsList();
  }, [fetchNpsList]);

  return { npsList, isLoading, error, refetch: fetchNpsList };
}
